import { Injectable, Inject } from '@angular/core';
import { Http } from '@angular/http';
import { APP_BASE_HREF } from '@angular/common';

@Injectable()
export class TestService {

  regularTableData = {
    columns: {
      id: { title: 'ID' },
      name: { title: 'Name' },
      country: { title: 'Country' },
      city: { title: 'City' },
      birthday: { title: 'Birthday' },
      age: { title: 'Age' },
      salary: { title: 'Salary' }
    },
    data: {}
  };

  constructor(
    private http: Http
  ) {
  }
  getTestFlightHours(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get('/assets/data/flighthours.json')
        .subscribe(
          data => {
            this.regularTableData.data = data.json();
            resolve(this.regularTableData);
          },
          err => reject()
        );
    });
  }
  getRegularTableData(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get('/assets/data/regular_table.json')
        .subscribe(
          data => {
            this.regularTableData.data = data.json();
            resolve(this.regularTableData);
          },
          err => reject()
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/test.service.ts